import {
    useRef
} from 'react';

import { SimpleGrid } from '@mantine/core';

import { useUsageRecords } from '../hooks/useUsageRecords.ts';
import { useTableColumns } from '../hooks/useTableColumns.tsx';
import { useUsageRecordsSelection } from '../hooks/useUsageRecordsSelection.ts';

import {
    MantineDataTable,
    TableSearchForm,
} from '@flexinet/ui-components';
import { DataTableTokenPagination } from "../../../components/DataTableTokenPagination.tsx";

export const RecordsTable = () => {
    const {selectedRecords, setSelectedRecords} = useUsageRecordsSelection();

    const {
        items,
        totalCount,
        loading,
        nextToken,
        fetchRecords,
        handleFilterByKeyword
    } = useUsageRecords();

    const { columns } = useTableColumns();

    const scrollViewportRef = useRef<HTMLDivElement>(null);

    return (
        <SimpleGrid verticalSpacing='xl' m='sm'>
            <TableSearchForm handleFilterByKeyword={handleFilterByKeyword} />

            <MantineDataTable
                columns={columns}
                records={items}
                selectedRecords={selectedRecords}
                onSelectedRecordsChange={setSelectedRecords}
                fetching={loading}
                onScrollToBottom={() => fetchRecords()}
                scrollViewportRef={scrollViewportRef}
                withTableBorder={true}
            />

            <DataTableTokenPagination totalCount={totalCount.toString()} nextToken={nextToken} handleLoadMore={fetchRecords} />

        </SimpleGrid>
    );
};